import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  BodyTextLarge, HeadlineTextLarge, TitleTextMedium,
} from 'Packages/FacetDesign/Components';

export const RetirementAgeGoalSeekViewResultsOverride = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => HeadlineTextLarge,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('disclaimer', {
    _component: () => BodyTextLarge,
  }, overrideReadOnly)
  .nameOverride(['primaryClientRetirementHeader', 'spouseClientRetirementHeader', 'endBalanceHeader'], {
    _component: () => TitleTextMedium,
  }, overrideReadOnly);
